export {default} from './Heading'
